import { memo } from 'react'
import { Text } from '@/components/Data'
import { Box } from '@/components/Layout'
import { partnersSliderStyles as styles } from './PartnersSlider.style'
import { partners } from './PartnersSlider.data'
import { Link } from 'react-router-dom'
import { useTranslations } from '@/core/translation'

function PartnersSlider() {
  const t = useTranslations('banner')

  return (
    <Box sx={styles.wrapper}>
      <Text sx={styles.heading}>{t('partners.title')}</Text>
      <Box sx={styles.listWrapper}>
        <Box sx={styles.list} component={'ul'}>
          {partners.map((partner) => (
            <Partner details={partner} key={partner.url} />
          ))}
          {partners.map((partner) => (
            <Partner details={partner} key={partner.url} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

function Partner({ details }: { details: (typeof partners)[0] }) {
  return (
    <Box component={'li'} key={details.url} sx={styles.listItem}>
      <Link to={details.url} target="_blank">
        <Box sx={styles.logo} component={details.img} />
      </Link>
    </Box>
  )
}

export default memo(PartnersSlider)
